var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { OldFooter, NewFooter } from './components';
import { groupTabLinks } from './utils/groupTabLinks';
/**
 * Componente Footer do Design System OLX
 */
export const Footer = _a => {
  var {
      firstTabLinks,
      secondTabLinks,
      thirdTabLinks
    } = _a,
    props = __rest(_a, ["firstTabLinks", "secondTabLinks", "thirdTabLinks"]);
  const firstGroupTabLinks = groupTabLinks(firstTabLinks);
  const secondGroupTabLinks = groupTabLinks(secondTabLinks);
  const thirdGroupTabLinks = groupTabLinks(thirdTabLinks);
  return props.newFooter ? React.createElement(NewFooter, Object.assign({}, props, {
    firstGroupTabLinks: firstGroupTabLinks,
    secondGroupTabLinks: secondGroupTabLinks,
    thirdGroupTabLinks: thirdGroupTabLinks
  })) : React.createElement(OldFooter, Object.assign({}, props));
};
export default Footer;